module.exports = __webpack_public_path__ + "media/images/business/img-feature-company-5d8ca8a546d599e96f423f5e7cad6728.png";